module.exports = __webpack_public_path__ + "img/img-3-7mobile.5ae73884.png";